module.exports = __webpack_public_path__ + "static/media/55.535fad9c.mp4";